import {
  ADD_EXPANDED_NODES,
  ADD_HIERARCHY_CHILD,
  CLEAR_HIERARCHY,
  CLOSE_EXPANDED_NODE,
  FETCH_HIERARCHY,
  FETCH_HIERARCHY_FAILURE,
  FETCH_HIERARCHY_SUCCESS,
  FETCH_PRODUCT_CHILDREN,
  FETCH_PRODUCT_CHILDREN_FAILURE,
  FETCH_PRODUCT_CHILDREN_SUCCESS,
} from '../actions/ProductHierarchyActions';

const initialState = {
  hierarchy: [],
  paginationList: {},
  expandedNodes: [],
  showMoreLoading: false,
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_HIERARCHY_CHILD:
      return {
        ...state,
        hierarchy: action.payload.updatedHierarchy,
      };

    case ADD_EXPANDED_NODES:
      return {
        ...state,
        expandedNodes: [
          ...state.expandedNodes,
          ...action.payload.nodes.filter((newNode) => !state.expandedNodes.includes(newNode)),
        ],
      };

    case CLOSE_EXPANDED_NODE:
      return {
        ...state,
        expandedNodes: state.expandedNodes.filter((node) => node !== action.payload.nodeId),
      };

    case FETCH_HIERARCHY:
      return {
        ...state,
        loading: true,
      };

    case FETCH_PRODUCT_CHILDREN:
      return {
        ...state,
        paginationList: {
          ...state.paginationList,
          [action.payload.itemId]: {
            isFetching: true,
          },
        },
      };

    case FETCH_HIERARCHY_SUCCESS:
      return {
        ...state,
        hierarchy: [action.payload.hierarchy],
        loading: false,
      };

    case FETCH_PRODUCT_CHILDREN_SUCCESS:
      return {
        ...state,
        hierarchy: action.payload.updatedHierarchy,
        paginationList: {
          ...state.paginationList,
          [action.payload.itemId]: {
            currentPageIndex: ++action.payload.currentPageIndex,
            isFetching: false,
          },
        },
      };

    case FETCH_PRODUCT_CHILDREN_FAILURE:
      return {
        ...state,
        paginationList: {
          ...state.paginationList,
          [action.payload.itemId]: {
            isFetching: false,
          },
        },
      };

    case FETCH_HIERARCHY_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case CLEAR_HIERARCHY:
      return initialState;

    default:
      return state;
  }
};
